(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-collection"]) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('.cc').forEach((root) => {
        if (root.dataset.motionInitialized) return;
        root.dataset.motionInitialized = 'true';
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        root.classList.add('cc-motion');
        const items = root.querySelectorAll('.cc-card, .cc-help > a, .cc-trust > div');
        items.forEach((item) => item.classList.add('cc-motion-item'));
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
            entry.target.classList.add('cc-in');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
        items.forEach((item) => observer.observe(item));
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["codex-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-tv2]').forEach((root) => {
        if (root.dataset.motionInitialized) return;
        root.dataset.motionInitialized = 'true';
        root.classList.add('tv2-ready');
        document.querySelector('.mm-announcement-bar')?.classList.add('tv2-banner-motion');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const heroSlider = root.querySelector('[data-tv2-hero]');
        if (heroSlider && !heroSlider.dataset.sliderInitialized) {
          heroSlider.dataset.sliderInitialized = 'true';
          heroSlider.classList.add('tv2-hero-slider-ready');
          const slides = [...heroSlider.querySelectorAll('[data-tv2-slide]')];
          const dots = [...heroSlider.querySelectorAll('[data-tv2-dot]')];
          let activeIndex = 0;
          let timer;
          let pointerStart = 0;
          const showSlide = (nextIndex, restart = true) => {
            activeIndex = (nextIndex + slides.length) % slides.length;
            slides.forEach((slide, index) => {
              const active = index === activeIndex;
              slide.classList.toggle('is-active', active);
              slide.setAttribute('aria-hidden', active ? 'false' : 'true');
              slide.inert = !active;
            });
            dots.forEach((dot, index) => {
              if (index === activeIndex) dot.setAttribute('aria-current', 'true');
              else dot.removeAttribute('aria-current');
            });
            if (restart && !reduceMotion) startRotation();
          };
          const stopRotation = () => window.clearInterval(timer);
          const startRotation = () => {
            stopRotation();
            timer = window.setInterval(() => showSlide(activeIndex + 1, false), 6000);
          };
          heroSlider.querySelector('[data-tv2-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
          heroSlider.querySelector('[data-tv2-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
          dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.tv2Dot))));
          heroSlider.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
          heroSlider.addEventListener('pointerup', (event) => {
            const distance = event.clientX - pointerStart;
            if (Math.abs(distance) > 45) showSlide(activeIndex + (distance < 0 ? 1 : -1));
          });
          showSlide(0, false);
          if (!reduceMotion) startRotation();
        }
        if (reduceMotion) return;
        root.classList.add('tv2-motion-ready');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
            entry.target.classList.add('tv2-in');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
        root.querySelectorAll('.tv2-reveal').forEach((element) => observer.observe(element));
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarvi-product-highlights"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-tp2]').forEach((root) => {
        if (root.dataset.motionInitialized) return;
        root.dataset.motionInitialized = 'true';
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        root.classList.add('tp2-motion-ready');
        const sections = [...root.querySelectorAll(':scope > .tp2-explainer, :scope > .tp2-tech, :scope > .tp2-benefits, :scope > .tp2-care')];
        const revealPassedSections = () => {
          sections.forEach((section) => {
            if (section.getBoundingClientRect().top < window.innerHeight * .9) section.classList.add('tp2-in');
          });
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
            entry.target.classList.add('tp2-in');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: .08 });
        sections.forEach((section) => observer.observe(section));
        revealPassedSections();
        window.addEventListener('scroll', revealPassedSections, { passive: true });
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
